import { getNamedModelsRequest } from 'api/Exec/api';
import { NamedModel, NamedModelsFilterParams } from 'api/Exec/types';
import getErrorFromPromiseReason from 'app/helpers/getErrorFromPromiseReason';

import { message } from 'antd';
import { useCallback, useState } from 'react';

const useNamedModels = () => {
  const [ isLoading, setIsLoading ] = useState<boolean>(false);
  const [ namedModels, setNamedModels ] = useState<NamedModel[]>([]);

  const fetchNamedModels = useCallback((filter?: NamedModelsFilterParams, abortController?: AbortController) => {
    setIsLoading(true);
    getNamedModelsRequest(filter, abortController)
      .then((response) => {
        setNamedModels(response.data);
      })
      .catch((reason) => {
        if (!abortController?.signal.aborted) {
          message.error(getErrorFromPromiseReason(reason));
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  return { namedModels, isLoading, fetchNamedModels, setNamedModels };
};

export default useNamedModels;
